<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M21 16C21 15.5 20.95 15.08 20.88 14.68L22.45 13.9L21.55 12.1L20.18
    12.79C19.63 11.96 18.91 11.5 18.29 11.28L18.95 9.32L17.05 8.68L16.29
    10.96C14.96 10.83 14.17 10.32 13.7 9.77L15.45 8.9L14.55 7.1L13 7.89C12.97
    7.59 12.86 6.72 12.28 5.87L13.83 3.55L12.17 2.44L10.76 4.56C10.28 4.33
    9.70004 4.15 9.00004 4.06V2H7.00004V4.1C6.29004 4.25 5.73004 4.54 5.32004
    4.91L2.70004 2.29L1.29004 3.71L4.24004 6.65C4.00004 7.39 4.00004 8 4.00004
    8H2.00004V10H4.04004C4.10004 10.63 4.21004 11.36 4.40004 12.15L1.68004
    13.05L2.31004 14.95L5.00004 14.05C5.24004 14.56 5.50004 15.08 5.82004
    15.58L3.44004 17.17L4.55004 18.83L7.07004 17.15C7.63004 17.71 8.29004 18.21
    9.06004 18.64L8.10004 20.55L9.89004 21.45L10.89 19.45L10.73 19.36C11.68
    19.68 12.76 19.9 14 19.97V22H16V19.93C16.76 19.84 17.81 19.64 18.77
    19.19L20.29 20.71L21.7 19.29L20.37 17.95C20.75 17.44 21 16.8 21 16ZM8.50004
    11C8.10221 11 7.72068 10.842 7.43938 10.5607C7.15807 10.2794 7.00004 9.89782
    7.00004 9.5C7.00004 9.10218 7.15807 8.72064 7.43938 8.43934C7.72068 8.15804
    8.10221 8 8.50004 8C8.89786 8 9.2794 8.15804 9.5607 8.43934C9.842 8.72064 10
    9.10218 10 9.5C10 9.89782 9.842 10.2794 9.5607 10.5607C9.2794 10.842 8.89786
    11 8.50004 11ZM11 14C10.7348 14 10.4805 13.8946 10.2929 13.7071C10.1054
    13.5196 10 13.2652 10 13C10 12.7348 10.1054 12.4804 10.2929 12.2929C10.4805
    12.1054 10.7348 12 11 12C11.2653 12 11.5196 12.1054 11.7071 12.2929C11.8947
    12.4804 12 12.7348 12 13C12 13.2652 11.8947 13.5196 11.7071 13.7071C11.5196
    13.8946 11.2653 14 11 14ZM15.5 17C15.1022 17 14.7207 16.842 14.4394
    16.5607C14.1581 16.2794 14 15.8978 14 15.5C14 15.1022 14.1581 14.7206
    14.4394 14.4393C14.7207 14.158 15.1022 14 15.5 14C15.8979 14 16.2794 14.158
    16.5607 14.4393C16.842 14.7206 17 15.1022 17 15.5C17 15.8978 16.842 16.2794
    16.5607 16.5607C16.2794 16.842 15.8979 17 15.5 17Z"
    />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "BacteriaIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
